module.exports = __webpack_public_path__ + "src/components/HomeBanner/mindShare.png?a4664002";


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeBanner/mindShare.png
// module id = 2803
// module chunks = 1